import { Navigate, useLocation } from "react-router-dom";
import { LoaderCircle } from "lucide-react";
import { useMemberAuth } from "@/member/MemberAuthContext";

export default function MemberProtectedRoute({ children }) {
  const { member, loading } = useMemberAuth(); const location = useLocation();
  if (loading) return <main className="flex min-h-screen items-center justify-center bg-[#f2efe7]" data-testid="member-auth-loading"><LoaderCircle className="animate-spin text-[#244234]" size={38}/></main>;
  if (!member) return <Navigate to="/member/login" replace state={{ from: location.pathname }} />;
  return children;
}